import { defineDictionary } from "gemi/client";

// New footer copy; the rest still reads the legacy SiteFooterV2 dictionary (#2046).
export const siteFooterV2Dict = defineDictionary({
  faq: {
    "en-US": "FAQ",
    "tr-TR": "SSS",
    "de-DE": "FAQ",
    "it-IT": "FAQ",
    "fr-FR": "FAQ",
    "es-ES": "FAQ",
    "ru-RU": "Вопросы и ответы",
  },
});
